import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Observer from 'react-intersection-observer';
import Filter from '../Filter.js';
import ToggleableIcon from '../ToggleableIcon.js';
import Autocomplete from '../Autocomplete.js';
import { GAfireEvent } from '../Tracking';
import { fireTag } from '../../libs/analytics.js';
import { COMMUNITIES_TO_COLORS } from "../../constants";
import ArrowRightWhite from "../../images/arrow__right-indigo.svg";


const communities = COMMUNITIES_TO_COLORS;

const GoMapButton = ({item}) => (
	<a className="go-map-button"
		/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
		href="/impact/map/?category=organizations-environment"
		tabIndex="0"
		role="button"
		aria-label="go button opens the map page in the same browser window"
	>
		Go
	</a>
)

const SearchForm = ({handleEvent, results, location, filterExpanded, showFilter, chooseDropdownType, checkForCityOrZip, mapLoading, alreadyShown, defaultCommunity}) => (
	<section className="search-controls">
		<form
			role="search"
			autoComplete="off"
			onSubmit={event => {
				event.preventDefault();
			}}
		>
			{/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
			<label id="search-label" htmlFor="search-input">Find an organization near you</label>
			<Autocomplete
				orgResults={results.all}
				checkForCityOrZip={checkForCityOrZip}
				handleTextSearch={
					inputObj => {
						handleEvent({
							action: 'input',
							name: 'results',
							value: inputObj,
							origin: 'sustainability'
						});
						handleEvent({
							action: 'search',
							type: 'input',
							name: 'results',
							origin: 'sustainability'
						});
					}}
				route="sustainability"
			/>
		</form>
		<div className={classNames('filter-controls', !mapLoading ? (showFilter ? 'cd-open more' : 'cd-open') : (alreadyShown ? 'cd-open' : ''))}>
			<p>Or filter nationally by cause type</p>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
			<div
				className="filter-panel-dropdown"
				onClick={() => handleEvent({action: 'toggle', type: 'Filter', name: 'sustainability', origin: 'sustainability'})}
			>

				<button type="button" className={`toggle type full  ${defaultCommunity ? 'has-default' : ''}`} aria-label="Or filter nationally by cause type Select a category down arrow opens category dropdown" aria-expanded={filterExpanded()}>
					<span className={`swatch ${communities[defaultCommunity]}`}/>

					{defaultCommunity}

					<ToggleableIcon isUp={showFilter} className="indicator"/>
				</button>

				<Filter
					{...{location}}
					handleFilterClick={community => chooseDropdownType(community, 'sustainability')}
					styles={classNames('menu-dropdown', {open: showFilter})}
					expanded={filterExpanded()}
					isDropdown
					defaultCommunity='Environment'
				/>
			</div>
			{/*<a href="/map/?category=organizations-environment" className="container__arrow"><img alt="White Right Arrow" src={ArrowRightWhite} /></a>*/}
			<GoMapButton/>


		</div>
	</section>
)


const SustainabilityMap = ({
							   uiState,
							   handleEvent,
							   resetMap,
							   chooseDropdownType,
							   mapLoading,
							   alreadyShown,
							   location,
							   results,
							   checkForCityOrZip,
							   enableScrollGA,
						   }) => {

	const {showFilter, input} = uiState;


	const filterExpanded = () => !!showFilter;

	const containerRef = useRef(null)

	useEffect(() => {

	});

	let scrollMap = false;

	useEffect(() => {


		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/sustainability/') && !scrollMap && document.querySelector('#find-local').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollMap = true;
				fireTag('S6');
			}
		});
		
	},[])

	return (
		<Observer
			tag='section'
			className="sustainability-page map"
			id="find-local"
			ref={containerRef}
			triggerOnce
			threshold={0.50}
			onChange={inView => {
				if (inView && enableScrollGA) {
					//GAfireEvent('isf_S5');
					//fireTag('S6');
				}
			}}
		>
			<div className='content-pillar'>
				<div className="bar"/>
				<h2 tabIndex="-1" className="search-copy">Explore how we're making an impact nationwide</h2>
			</div>
			{/* MAP */}
			<div className="map-container">
				<a
					href="/impact/map/?category=organizations-environment"
					onClick={() => {
						//GAfireEvent('isf_C22');
						resetMap();
					}}
				>
					<figure className="map-image" aria-label="Map of United States showing dots representing organizations helped by Wells Fargo."/>
				</a>
			</div>
			<div className="map-overlay">
				<SearchForm
					handleEvent={handleEvent}
					input={input}
					results={results}
					checkForCityOrZip={checkForCityOrZip}
					chooseDropdownType={chooseDropdownType}
					location={location}
					filterExpanded={filterExpanded}
					showFilter={showFilter}
					mapLoading={mapLoading}
					alreadyShown={alreadyShown}
					defaultCommunity="Environment"
				/>
			</div>
		</Observer>
	);
}

export default SustainabilityMap;

